import { TOUR_TRANSLATIONS } from "../translations"

export const getSellerDeepDiveSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="seller-deep-dive-filters"]',
            title: t.sellerDeepDiveFilters.title,
            content: t.sellerDeepDiveFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="seller-deep-dive-chart"]',
            title: t.sellerDeepDiveChart.title,
            content: t.sellerDeepDiveChart.content,
        },
        {
            target: '[data-tour="seller-deep-dive-table"]',
            title: t.sellerDeepDiveTable.title,
            content: t.sellerDeepDiveTable.content,
        },
        {
            target: '[data-tour="seller-deep-dive-create-report"]',
            title: t.sellerDeepDiveCreateReport.title,
            content: t.sellerDeepDiveCreateReport.content,
        },
    ]
}
